interface IProps {
  label: string;
  description: string;
  values: { add?: string; sph?: string; cyl?: string; axis?: string };
}

const EyeMeasurement = ({ label, description, values }: IProps) => {
  return (
    <div className="grid grid-cols-5 items-end gap-4">
      <div className="col-span-1">
        <p className="font-bold">{label}</p>
        <p className="text-nowrap break-keep">{description}</p>
      </div>
      <div className="col-span-1">
        <p>{values.sph || "-"}</p>
      </div>
      <div className="col-span-1">
        <p>{values.cyl || "-"}</p>
      </div>
      <div className="col-span-1">
        <p>{values.axis || "-"}</p>
      </div>
      <div className="col-span-1">
        <p>{values.add || "-"}</p>
      </div>
    </div>
  );
};

export default EyeMeasurement;
